var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 22,
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.56667C5 6.1933 5 6.00661 5.07266 5.86401C5.13658 5.73857 5.23857 5.63658 5.36401 5.57266C5.50661 5.5 5.6933 5.5 6.06667 5.5H15.9333C16.3067 5.5 16.4934 5.5 16.636 5.57266C16.7615 5.63658 16.8634 5.73857 16.9273 5.86401C17 6.00661 17 6.1933 17 6.56667V7.72484C17 7.8879 17 7.96943 16.9816 8.04615C16.9653 8.11418 16.9383 8.17921 16.9017 8.23885C16.8605 8.30613 16.8029 8.36379 16.6876 8.47909L12.6457 12.5209C12.5305 12.6362 12.4728 12.6939 12.4316 12.7611C12.395 12.8208 12.3681 12.8858 12.3517 12.9539C12.3333 13.0306 12.3333 13.1121 12.3333 13.2751V14.8333L9.66667 17.5V13.2751C9.66667 13.1121 9.66667 13.0306 9.64825 12.9539C9.63191 12.8858 9.60498 12.8208 9.56843 12.7611C9.5272 12.6939 9.46955 12.6362 9.35425 12.5209L5.31242 8.47909C5.19712 8.36379 5.13947 8.30613 5.09824 8.23885C5.06169 8.17921 5.03475 8.11418 5.01842 8.04615C5 7.96943 5 7.8879 5 7.72484V6.56667Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.136d70e8de31e52bbdf3e5b61d3e43a3.svg";
export { ForwardRef as ReactComponent };